import type {
    AppModule,
    AppSubmodule,
    ExposedMenu,
    MenuGroup,
    SideLink,
} from '@moniebook-web/components/widgets/sidebar';
import { ArrowLeftLongLine } from '@moniebook-web/icons/arrows/arrow-left-long-line';
import { StickyNoteAddLine } from '@moniebook-web/icons/document/sticky-note-add-line';
import { DiscountPercentLine } from '@moniebook-web/icons/finance/discount-percent-line';
import { PriceTagLine } from '@moniebook-web/icons/finance/price-tag-line';
import { ShoppingBasket2Line } from '@moniebook-web/icons/finance/shopping-basket-2-line';
import { Sales } from '@moniebook-web/icons/sidebar-rail/sales';
import { ApplicationModule, MENU_SECTIONS } from '@moniebook-web/types';

const PHYSICAL_SALES_SIDEBAR_COLOR = '#0357EE';

const ORDERS_BASE_FILTER_KEYS = [
    'saleDateFrom',
    'saleDateTo',
    'staff',
    'branches',
    'register',
    'page',
    'pageSize',
    'paymentStatus',
    'customers',
];

export const ordersMenu: ExposedMenu = {
    menuGroups: [
        {
            id: 'sales',
            name: 'Sales',
            sectionId: MENU_SECTIONS.NONE,
            order: 2,
            icon: <DiscountPercentLine />,
            color: PHYSICAL_SALES_SIDEBAR_COLOR,
        },
    ] as MenuGroup[],
    submenu: [
        {
            sectionId: MENU_SECTIONS.NONE,
            order: 1,
            accessCodeList: [
                'VIEW_COMPLETED_SALE',
                'VIEW_SALE',
                'VIEW_OWN_COMPLETED_SALE',
            ],
            grantAccessIfAny: true,
            name: 'Completed Sales',
            to: '/dashboard/sales/completed',
            icon: <PriceTagLine />,
            parentId: 'sales',
            keepSearchParams: true,
            keepSearchList: ORDERS_BASE_FILTER_KEYS,
        },
        {
            sectionId: MENU_SECTIONS.NONE,
            order: 2,
            accessCodeList: [
                'VIEW_OUTSTANDING_SALE',
                'VIEW_SALE',
                'VIEW_OWN_OUTSTANDING_SALE',
            ],
            grantAccessIfAny: true,
            name: 'Outstanding Sales',
            to: '/dashboard/sales/outstanding',
            icon: <ShoppingBasket2Line />,
            parentId: 'sales',
            keepSearchParams: true,
            keepSearchList: ORDERS_BASE_FILTER_KEYS,
        },
        {
            sectionId: MENU_SECTIONS.NONE,
            order: 3,
            accessCodeList: [
                'VIEW_SALE',
                'VIEW_COMPLETED_SALE',
                'VIEW_OWN_COMPLETED_SALE',
            ],
            grantAccessIfAny: true,
            name: 'Returns',
            to: '/dashboard/sales/refunds',
            icon: <ArrowLeftLongLine />,
            parentId: 'sales',
            keepSearchParams: true,
            keepSearchList: ORDERS_BASE_FILTER_KEYS,
            featureFlag: 'moniebook.pos.enableRefunds',
        },
        {
            sectionId: MENU_SECTIONS.NONE,
            order: 4,
            accessCodeList: ['VIEW_SAVED_CART_HISTORY'],
            grantAccessIfAny: true,
            name: 'Carts',
            to: '/dashboard/sales/carts',
            icon: <StickyNoteAddLine />,
            parentId: 'sales',
            keepSearchParams: true,
            keepSearchList: ORDERS_BASE_FILTER_KEYS,
        },
    ] as SideLink[],
    modules: [
        {
            id: 'sales',
            name: 'Sales',
            order: 2,
            icon: <Sales />,
            backgroundColor: '#DCFCE7',
            foregroundColor: '#16A34A',
        },
    ] as AppModule[],
    subModules: [
        {
            parentId: ApplicationModule.SALES,
            order: 1,
            accessCodeList: [
                'VIEW_COMPLETED_SALE',
                'VIEW_SALE',
                'VIEW_OWN_COMPLETED_SALE',
            ],
            grantAccessIfAny: true,
            name: 'Completed Sales',
            to: '/dashboard/sales/completed',
            icon: <PriceTagLine />,
            keepSearchParams: true,
            keepSearchList: ORDERS_BASE_FILTER_KEYS,
        },
        {
            parentId: ApplicationModule.SALES,
            order: 2,
            accessCodeList: [
                'VIEW_OUTSTANDING_SALE',
                'VIEW_SALE',
                'VIEW_OWN_OUTSTANDING_SALE',
            ],
            grantAccessIfAny: true,
            name: 'Outstanding Sales',
            to: '/dashboard/sales/outstanding',
            icon: <ShoppingBasket2Line />,
            keepSearchParams: true,
            keepSearchList: ORDERS_BASE_FILTER_KEYS,
        },
        {
            parentId: ApplicationModule.SALES,
            order: 3,
            accessCodeList: [
                'VIEW_SALE',
                'VIEW_COMPLETED_SALE',
                'VIEW_OWN_COMPLETED_SALE',
            ],
            grantAccessIfAny: true,
            name: 'Returns',
            to: '/dashboard/sales/refunds',
            icon: <ArrowLeftLongLine />,
            keepSearchParams: true,
            keepSearchList: ORDERS_BASE_FILTER_KEYS,
            featureFlag: 'moniebook.pos.enableRefunds',
        },
        {
            parentId: ApplicationModule.SALES,
            order: 4,
            accessCodeList: ['VIEW_SAVED_CART_HISTORY'],
            grantAccessIfAny: true,
            name: 'Carts',
            to: '/dashboard/sales/carts',
            icon: <StickyNoteAddLine />,
            keepSearchParams: true,
            keepSearchList: ORDERS_BASE_FILTER_KEYS,
        },
    ] as AppSubmodule[],
};
